import { useRouteQuery } from "@vueuse/router";
import { upperCase } from "lodash-es";

export const useRouteCountry = (defaultValue?: string) =>
  useRouteQuery("country", defaultValue, {
    mode: "push",
    transform: upperCase,
  });
